(function() {
  const initializeAccordion = () => {
    const accordionHeaders = document.querySelectorAll('.f-navlist p');

    // Restore open submenu index from sessionStorage
    const openIndex = sessionStorage.getItem('openFooterSubmenu');
    if (openIndex !== null && accordionHeaders[openIndex]) {
      accordionHeaders[openIndex].classList.add('active');
      const content = accordionHeaders[openIndex].nextElementSibling;
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    accordionHeaders.forEach((header, index) => {
      header.removeEventListener('click', toggleAccordion);
      header.addEventListener('click', (event) => toggleAccordion(event, index));
    });
  };

  const toggleAccordion = (event, index) => {
    const clickedHeader = event.currentTarget;
    const accordionHeaders = document.querySelectorAll('.f-navlist p');
    const activeHeader = document.querySelector('.f-navlist p.active');

    // Close previously active, if it's not the clicked one
    if (activeHeader && activeHeader !== clickedHeader) {
      activeHeader.classList.remove('active');
      if (activeHeader.nextElementSibling) {
        activeHeader.nextElementSibling.style.maxHeight = 0;
      }
    }

    // Toggle clicked header
    clickedHeader.classList.toggle('active');
    const content = clickedHeader.nextElementSibling;

    if (content) {
      if (clickedHeader.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        // Save index in sessionStorage
        sessionStorage.setItem('openFooterSubmenu', index);
      } else {
        content.style.maxHeight = 0;
        // Remove from sessionStorage if closing
        sessionStorage.removeItem('openFooterSubmenu');
      }
    }
  };

  initializeAccordion();
})();

// Size guide

/////// ND Accordion – PDP Only ///////
document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelector(".nd-accordion");
  if (!accordion) return;

  const openItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    if (!panel) return;

    panel.style.maxHeight = panel.scrollHeight + "px";
    item.classList.add("active");
  };

  const closeItem = (item) => {
    const panel = item.querySelector(".nd-panel");
    if (!panel) return;

    panel.style.maxHeight = "0px";
    item.classList.remove("active");
  };

  const firstItem = accordion.querySelector(".nd-item");
  if (firstItem) openItem(firstItem);

  accordion.addEventListener("click", function (e) {
    const trigger = e.target.closest(".nd-trigger");
    if (!trigger) return;

    const item = trigger.closest(".nd-item");
    if (!item) return;

    const activeItem = accordion.querySelector(".nd-item.active");

    if (activeItem && activeItem !== item) {
      closeItem(activeItem);
    }

    if (item.classList.contains("active")) {
      closeItem(item);
    } else {
      openItem(item);
    }
  });
});

// product accordion start
(function () {
  if (!matchMedia("(max-width: 950px)").matches) return;

  const THRESH = 35;
  const DUR = 260;
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  function animate(el, to) {
    const from = el.scrollLeft;
    const diff = to - from;
    if (!diff) return;

    const start = performance.now();
    if (el.__raf) cancelAnimationFrame(el.__raf);

    const tick = (now) => {
      const t = Math.min(1, (now - start) / DUR);
      el.scrollLeft = from + diff * ease(t);
      if (t < 1) el.__raf = requestAnimationFrame(tick);
    };

    el.__raf = requestAnimationFrame(tick);
  }

  document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((cmp) => {
    const track = cmp.querySelector('ul[id^="Slider-Gallery-"]');
    if (!track) return;

    // hard-disable native snapping & smooth
    track.style.scrollSnapType = "none";
    track.style.scrollBehavior = "auto";

    const slides = () => [...track.querySelectorAll("li.slider__slide")];

    const nearest = () => {
      const s = slides();
      if (!s.length) return 0;
      const left = track.scrollLeft;
      let best = 0, min = Infinity;
      for (let i = 0; i < s.length; i++) {
        const d = Math.abs(s[i].offsetLeft - left);
        if (d < min) { min = d; best = i; }
      }
      return best;
    };

      const go = (i) => {
      const s = slides();
      if (!s.length) return;
      if (i < 0) i = s.length - 1;
      if (i >= s.length) i = 0;
      animate(track, s[i].offsetLeft);
      };

    // touch = 1 step
    let startX = 0, startI = 0, dragging = false;

    track.addEventListener("touchstart", (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      dragging = true;
      startX = t.clientX;
      startI = nearest();
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
      if (!dragging) return;
      dragging = false;

      const x = (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || startX;
      const dx = x - startX;

      if (Math.abs(dx) < THRESH) return go(startI);
      go(dx < 0 ? startI + 1 : startI - 1);
    }, { passive: true });

    // wheel/trackpad = 1 step per gesture
    let lock = false, acc = 0, resetT = null;

    track.addEventListener("wheel", (e) => {
      if (dragging) return;
      e.preventDefault();

      const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      acc += d;

      clearTimeout(resetT);
      resetT = setTimeout(() => (acc = 0), 120);

      if (lock || Math.abs(acc) < 35) return;
      lock = true;

      go(nearest() + (acc > 0 ? 1 : -1));

      setTimeout(() => { lock = false; acc = 0; }, 420);
    }, { passive: false });
  });
})();
// product accordion end


// cart Drawer///
function initPaymentScrollbars(root = document) {
    root.querySelectorAll('[data-payment-scroll]').forEach((paymentRow) => {
      if (paymentRow.dataset.scrollbarReady === 'true') return;

      const wrap = paymentRow.closest('.nd-cart-payments-wrap');
      const scrollbar = wrap?.querySelector('[data-payment-scrollbar]');
      const thumb = wrap?.querySelector('[data-payment-thumb]');

      if (!scrollbar || !thumb) return;

      const updateScrollbar = () => {
        const visibleWidth = paymentRow.clientWidth;
        const contentWidth = paymentRow.scrollWidth;
        const trackWidth = scrollbar.clientWidth;

        if (!visibleWidth || !contentWidth || !trackWidth) return;

        if (contentWidth <= visibleWidth + 1) {
          scrollbar.style.display = 'none';
          thumb.style.transform = 'translateX(0)';
          return;
        }

        scrollbar.style.display = 'block';

        const thumbWidth = Math.max(
          30,
          Math.min(trackWidth, (visibleWidth / contentWidth) * trackWidth)
        );

        const maxScrollLeft = contentWidth - visibleWidth;
        const maxThumbLeft = trackWidth - thumbWidth;
        const thumbLeft =
          maxScrollLeft > 0
            ? (paymentRow.scrollLeft / maxScrollLeft) * maxThumbLeft
            : 0;

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbLeft}px)`;
      };

      paymentRow.addEventListener(
        'scroll',
        () => requestAnimationFrame(updateScrollbar),
        { passive: true }
      );

      window.addEventListener('resize', updateScrollbar);

      const resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(updateScrollbar);
      });

      resizeObserver.observe(paymentRow);
      resizeObserver.observe(wrap);

      const refreshScrollbar = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(updateScrollbar);
        });
      };

      refreshScrollbar();
      setTimeout(refreshScrollbar, 100);
      setTimeout(refreshScrollbar, 300);
      setTimeout(refreshScrollbar, 600);
      setTimeout(refreshScrollbar, 1000);

      paymentRow.dataset.scrollbarReady = 'true';
    });
  }

  function refreshPaymentScrollbars() {
    document.querySelectorAll('[data-payment-scroll]').forEach((paymentRow) => {
      paymentRow.dispatchEvent(new Event('scroll'));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPaymentScrollbars();
  });

  document.addEventListener('cart:updated', () => {
    requestAnimationFrame(() => {
      initPaymentScrollbars();
      refreshPaymentScrollbars();
    });
  });

  document.addEventListener('click', (event) => {
    const cartTrigger = event.target.closest(
      '#cart-icon-bubble, [id*="cart-icon-bubble"], a[href="/cart"], [data-cart-drawer-trigger]'
    );

    if (!cartTrigger) return;

    setTimeout(refreshPaymentScrollbars, 100);
    setTimeout(refreshPaymentScrollbars, 300);
    setTimeout(refreshPaymentScrollbars, 600);
  });

  const paymentScrollbarObserver = new MutationObserver(() => {
    initPaymentScrollbars();
  });

  paymentScrollbarObserver.observe(document.body, {
    childList: true,
    subtree: true
  });